const LOG_PREFIX = 'AFFILIATES SDK :: '
export default {
  log: (...messages) => {
    console.log(LOG_PREFIX, ...messages)
  },
  error: (...messages) => {
    console.error(LOG_PREFIX, 'Error:', ...messages)
  },
  warn: (...messages) => {
    console.warn(LOG_PREFIX, 'Warning:', ...messages)
  },
}
